import { useNavigate } from "react-router-dom";
import PageContainer from '../common/PageContainer'
import s from './SocialScreen.module.css'
import imgStep from "../../assets/images/soc_step.webp"
import imgStepComplete from "../../assets/images/soc_step_complete.webp"
import imgCheck from "../../assets/images/check.webp"
import imgBadge from "../../assets/images/soc_badge.webp"
import imgCoin from "../../assets/images/coin.webp"
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { useEffect } from "react";
import telegramWebAppAPI from "../../services/telegram";

interface SocialItem {
    completeState: number;
    imgSrc: string;
    imgSrcComplete: string;
    count: string;
    title: string;
    text: string;
    textBtn: string;
}

interface SocialScreenProps {
    socialData: SocialItem[]
}

const SocialScreen: React.FC<SocialScreenProps> = ({ socialData = [] }) => {
    const dispatch = useDispatch();
    const user = useSelector((state: RootState) => state.game.user);
    const { metadata } = useSelector((state: RootState) => state.game);
    const navigate = useNavigate();

    useEffect(() => {
        if (user.active_state < 1) {
            navigate('/welcome');
        }

        if (user.active_state >= 14) {
            navigate("/main");
        }
    }, [user.active_state]);

    const manageStep = (stepCompleteState: number) => {
        let retries = [1000];

        switch (stepCompleteState) {
            // telegram
            case 2:
                retries = [2000,5000,10000];
                telegramWebAppAPI.openTelegramLink(metadata.telegram);
                break;
            // twitter
            case 4:
                if ((user.active_state & 2) == 0) {
                    return;
                }
                telegramWebAppAPI.openLink(metadata.twitter);
                break;
            // waitlist
            case 8:
                if ((user.active_state & 2) == 0 || (user.active_state & 4) == 0) {
                    return;
                }

                break;
        }

        for (let tm of retries) {
            setTimeout(() => {
                dispatch({ type: 'game/updateState', payload: stepCompleteState })
            }, tm);
        }
    }

    const firstIncompleteIndex = socialData.findIndex(({ completeState }) => {
        return (completeState & user.active_state) === 0;
    });


    return (
        <PageContainer>

            <div className={s.titleContainer}>
                <h1 className={s.title}>BE FIRST!</h1>
                <p className={s.textTop}>Unlock exclusive early access<br />in just 3 easy steps.<span className={s.textTopSpan}> Join the airdrop!</span></p>
            </div>

            <div className={s.containerScroll}>
                <div className={s.listContainer}>
                    {socialData.map(({ completeState, imgSrc, imgSrcComplete, count, title, text, textBtn }, index) => {
                        const isComplete = (completeState & user.active_state) > 0;
                        let buttonClass = s.inactiveBG;
                        if (isComplete) {
                            buttonClass = s.completeBG;
                        } else if (index === firstIncompleteIndex) {
                            buttonClass = s.incompleteBG;
                        }
                        return (
                            <div className={`${isComplete ? s.listItemComplete : ""}`} key={index}>
                                <div className={s.listItem}>
                                    <div className={s.avaBox}>
                                        <div className={`${s.count} ${isComplete ? s.complete : s.incomplete}`}>
                                            {count}
                                        </div>
                                        <img className={s.avaImg} src={`${isComplete ? imgSrcComplete : imgSrc}`} alt={title} />
                                    </div>
                                    <div className={s.textBox}>
                                        <h3 className={s.listTitle}>{title}</h3>
                                        <p className={s.listText}>{text}</p>
                                    </div>

                                    <button
                                        className={`${s.button} ${buttonClass}`}
                                        onClick={() => { if (index === firstIncompleteIndex) manageStep(completeState); }}
                                        type="button"
                                        disabled={index !== firstIncompleteIndex} // 🔒 блокируем остальные
                                    >
                                        <p className={s.btnText}>
                                            {isComplete ? "Completed" : textBtn}
                                        </p>
                                    </button>

                                    <div className={s.rewardBox}>
                                        <img className={s.imgCoin} src={imgCoin} alt="coin" />
                                        <p className={s.rewardText}>+100 <br /> Points</p>
                                    </div>

                                </div>
                                {isComplete && <p className={s.missionText}>mission accomplished</p>}
                            </div>
                        );
                    })}
                </div>
            </div>

            <div className={s.checkContainer}>
                <div className={s.checkBox}>
                    {socialData.map(({ completeState }, index) => {
                        const isComplete = (completeState & user.active_state) > 0;
                        return (
                            <div className={s.itemStep} key={index}>
                                {isComplete && <img className={s.imgCheck} src={imgCheck} alt='step' />}
                                <img className={s.imgStep} src={`${isComplete ? imgStepComplete : imgStep}`} alt='step' />
                            </div>
                        )
                    })}
                </div>
                <div className={s.badgeBox}>
                    <img className={s.imgBadge} src={imgBadge} alt='badge' />
                    <p className={s.rewardText}>Complete all<br />three steps and<br />get a reward</p>
                    <div className={s.balanceBox}>
                        <p className={s.balanceText}>BALANCE</p>
                        <div className={s.coinBox}>
                            <img className={s.imgCoin} src={imgCoin} alt="coin" />
                            <p className={s.balanceTextValue}>{user.tokens}<br /><span className={s.spanText}>points</span></p>
                        </div>

                    </div>
                </div>
            </div>
            <div className={s.glow}></div>
        </PageContainer >
    )
}


export default SocialScreen